<template>
    <div class="static-content-wrapper">
        <template v-if="content">
            <GlobalM />
            <div class="wrapper">
                <template v-for="cnt in content">
                    <MedauLine :content="cnt" />
                </template>
                <MedauFooter />
            </div>
        </template>
        <template v-else>
        </template>
    </div>
</template>

<script>
import MedauLine from "@/components/elements/MedauLine.vue";
import MedauFooter from "@/components/static/MedauFooter.vue";
import GlobalM from "@/components/elements/GlobalM.vue";

export default {
    components: {GlobalM, MedauFooter, MedauLine},
    data() {
        return {
            content: null,
        };
    },
    watch: {
        page(val, ignored_oldVal) {
            this.loadContent();
        }
    },
    computed: {
        page() {
            return this.$route.params.page;
        }
    },
    methods: {
        loadContent() {
            if(this.page === undefined) {
                return;
            }
            this.apiRequest('/pages?fields[]=EindeutigeBezeichnung&fields[]=Titel' +
                '&filters[EindeutigeBezeichnung][$eq]=' + this.page + '&populate=deep')
                .then(cnt => {
                    if(cnt.data.length < 1) {
                        this.$router.push('/nicht-gefunden');
                        return;
                    }
                    this.content = cnt.data[0].attributes?.Inhalt || null;
                    const title = cnt.data[0].attributes?.Titel || null;
                    if(title) {
                        this.$store.commit("setPageTitle", title);
                    } else {
                        this.$store.commit("setPageTitle", "Home");
                    }
                    this.handleSEOObject(cnt.data[0].attributes?.seo || null);
                })
                .catch(() => this.content = false);
        }
    },
    mounted() {
        this.loadContent();
        document.body.classList.add("clicked");
        this.$store.commit("setClickedField", null);
    },
}
</script>